export default "/images/dd233ebb77f2a9948808b6402b00a6b7.avif";